import React from "react";

import {
  Box,
  Card,
  CardContent,
  CardActionArea,
  CardHeader,
  Chip,
  Typography,
  SvgIcon,
  SvgIconProps
} from '@mui/material';
import { useTheme, alpha } from "@mui/material/styles";

import { Option } from "@/options";


interface ConnectCardProps {
  option: Option;
  disabled: boolean;
}

const MenuCard: React.FC<ConnectCardProps> = (
  {
    option,
    disabled
  }
) => {

  const theme = useTheme();

  return (
    <Box position="relative">
      <Card
        sx={{
          border: 1,
          borderRadius: 1,
          borderColor: theme.palette.divider,
          height: "320px",
          width: "260px"
      }}
      >
        <CardActionArea
          onClick={() => window.open(option.url, '_blank') }
          disabled={disabled}
          sx={{
            height: '100%',
            display: 'flex',
            flexDirection: 'column'
          }}
        >
          <CardHeader
            disableTypography
            title={
            option.logo ?
                option.logo
              :
              <Typography
                variant="h5"
                sx={{
                  fontFamily: option.font ?? 'cera-pro-bold',
                  textAlign: 'center'
                }}
              >
                {option.name}
              </Typography>
            }
            sx={{ height: '76px', pb: 1 }}
          />
          <CardContent sx={{ display: 'flex', flexGrow: 1}}>
            <Typography sx={{ textAlign: 'center' }}>
              {option.description}
            </Typography>
          </CardContent>
        </CardActionArea>
      </Card>
      {disabled &&
        <Box
          position="absolute"
          top={0}
          left={0}
          width="100%"
          height="100%"
          zIndex={2}
          sx={{
            backgroundColor: alpha(theme.palette.background.default, 0.5)
          }}
        />
      }
      {option.new &&
        <Chip
          size="small"
          color="primary"
          label={'NEW'}
          sx={{
            position: 'absolute',
            bottom: 8,
            right: 8,
            zIndex: 1,
          }}
        />
      }
    </Box>
  )
}

export default MenuCard;
